import { render, staticRenderFns } from "./RsaAccettazioneImpegnativaListComponent.vue?vue&type=template&id=2c998f1c"
import script from "./RsaAccettazioneImpegnativaListComponent.vue?vue&type=script&lang=js"
export * from "./RsaAccettazioneImpegnativaListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports